// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__19ad5","content":"GlobalSearch_content__V-EP5"};